import React from 'react';

import  EVSCCA2025  from 'views/EVSCCA2025';
const BlogNewsroomPage = () => {

return <EVSCCA2025/>
};

export default BlogNewsroomPage;